/** Self-hosted GlitchTip (Sentry protocol). Public DSN; env vars override it when non-empty. */
export const GLITCHTIP_DSN =
  "https://5e5f61595a3347d2ad8336afcb16f9d3@rpscripts.net/_e/12";

/** Errors only, production only: GlitchTip ignores tracing/replay/logs. */
export const sharedSentryOptions = {
  environment: process.env.NODE_ENV || "development",
  enabled: process.env.NODE_ENV === "production",
};
